import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { VacationTypeService } from '../vacation-type.service';
import { VacationType } from '../../../models/lookups/vacationType.model';
import { DisplayModes } from '../../../models/enums';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';

@Component({
  selector: 'crm-vacation-type-add',
  templateUrl: './vacation-type-add.component.html',
  styleUrls: ['./vacation-type-add.component.css']
})
export class VacationTypeAddComponent implements OnInit {

  vacationType: VacationType = new VacationType();
  minStartDate: Date = new Date();
  //vacationTypeid: number;
  displayMode: DisplayModes = DisplayModes.Success;
  en: any;
  isVac: boolean = false;


  @Output() closeEvent = new EventEmitter<boolean>();
  @Output() showProvision = new EventEmitter<boolean>();
  @Input() vacationTypeid: number;
  constructor(private alertService: AlertService,
    private route: ActivatedRoute,
    private vacationTypeService: VacationTypeService,
    private translateService: AppTranslationService,
    private router: Router) { }

  ngOnInit() {
    this.isVac = this.router.url.indexOf('vacation') > -1;
    if (this.vacationTypeid != undefined)
      this.getDetails(this.vacationTypeid);
  }

  /** Credit is whole or half days, 0 to 366. */
  get creditInvalid(): boolean {
    const credit = Number(this.vacationType.defaultCredit);
    return this.vacationType.hasCredit && (this.vacationType.defaultCredit === null || this.vacationType.defaultCredit === undefined
      || isNaN(credit) || credit < 0 || credit > 366 || credit * 2 !== Math.floor(credit * 2));
  }

  onCreditToggle() {
    if (this.vacationType.hasCredit && (this.vacationType.defaultCredit === null || this.vacationType.defaultCredit === undefined))
      this.vacationType.defaultCredit = 0;
    if (!this.vacationType.hasCredit)
      this.vacationType.isRestricted = false;
  }

  save(form) {
    this.vacationType.isVacation = this.isVac;
    if (!this.isVac) {
      this.vacationType.hasCredit = false;
      this.vacationType.isRestricted = false;
    }
    if (!form.invalid && !this.creditInvalid) {
      this.displayMode = DisplayModes.Loading;
      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.vacationTypeService.Save(this.vacationType).subscribe(result => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        if (this.vacationType.id == 0)
          this.vacationType = new VacationType();
        else
          this.closeEvent.emit(true);

        this.alertService.showMessage("", this.translateService.getTranslation("SavedSuccessfully"), MessageSeverity.Success);
      }, err => {
        this.alertService.stopLoadingMessage();
        // a business rule (e.g. the credit) comes back as { Message }: show it and keep the form
        const message = err && err.error && (err.error.Message || err.error.message);
        if (message) {
          this.displayMode = DisplayModes.Success;
          this.alertService.showMessage("", message, MessageSeverity.Error);
          return;
        }
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }

  getDetails(id) {
    this.displayMode = DisplayModes.Loading;
    this.vacationTypeService.GetById(id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.vacationType = response as VacationType;
    }, err => {
      this.displayMode = DisplayModes.Error;
    });
  }

  showProvisionModal() {
    this.showProvision.emit(true);
  }
}
